import React from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
// import StepLabelButton from '@material-ui/core/StepLabelButton';

import { connect } from 'react-redux';
// redux
import {
  applicantAction,
  clearApplicantDocument
} from '../../../redux/actions/applicantAction';
import {
  initAppID,
  applicationIDAction,
  getApplicationList
} from '../../../redux/actions/applicationAction';

import * as styles from './stepperStyle';
import { ColorlibConnector } from './stepperStyle';
import Profile from './Profile';
import PassportData from './PassportData';
import { Grid } from '@material-ui/core';
import Address from './Address';
import BankAcount from './BankAcount';
import TableChildren from './TableChildren';
import Scans from './Scans';
import Preview from './Preview';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

function getSteps() {
  return [
    'Персональні дані',
    'Паспортні дані',
    'Адреса',
    'Банківські реквізити',
    'Діти',
    'Документи',
    'Перегляд заповнених даних'
  ];
}

function getStepContent(step, stepperLogic) {
  switch (step) {
    case 0:
      return (
        <Profile
          handleApplicantChange={stepperLogic.handleApplicantChange}
          handleSelectApplicantChange={stepperLogic.handleSelectApplicantChange}
          handleBack={stepperLogic.handleBack}
          handleNext={stepperLogic.handleNext}
          activeStep={stepperLogic.activeStep}
          completedSteps={stepperLogic.completedSteps}
          totalSteps={stepperLogic.totalSteps}
          handleComplete={stepperLogic.handleComplete}
          steps={stepperLogic.steps}
          completed={stepperLogic.completed}
          setCompleted={stepperLogic.setCompleted}
          pathName={stepperLogic.pathName}
        />
      );
    case 1:
      return (
        <PassportData
          handleApplicantChange={stepperLogic.handleApplicantChange}
          handleSelectApplicantChange={stepperLogic.handleSelectApplicantChange}
          handleBack={stepperLogic.handleBack}
          handleNext={stepperLogic.handleNext}
          activeStep={stepperLogic.activeStep}
          completedSteps={stepperLogic.completedSteps}
          totalSteps={stepperLogic.totalSteps}
          handleComplete={stepperLogic.handleComplete}
          steps={stepperLogic.steps}
          completed={stepperLogic.completed}
          setCompleted={stepperLogic.setCompleted}
        />
      );
    case 2:
      return (
        <Address
          handleApplicantChange={stepperLogic.handleApplicantChange}
          handleSelectApplicantChange={stepperLogic.handleSelectApplicantChange}
          handleBack={stepperLogic.handleBack}
          handleNext={stepperLogic.handleNext}
          activeStep={stepperLogic.activeStep}
          completedSteps={stepperLogic.completedSteps}
          totalSteps={stepperLogic.totalSteps}
          handleComplete={stepperLogic.handleComplete}
          steps={stepperLogic.steps}
          completed={stepperLogic.completed}
          setCompleted={stepperLogic.setCompleted}
        />
      );
    case 3:
      return (
        <BankAcount
          handleApplicantChange={stepperLogic.handleApplicantChange}
          handleSelectApplicantChange={stepperLogic.handleSelectApplicantChange}
          handleBack={stepperLogic.handleBack}
          handleNext={stepperLogic.handleNext}
          activeStep={stepperLogic.activeStep}
          completedSteps={stepperLogic.completedSteps}
          totalSteps={stepperLogic.totalSteps}
          handleComplete={stepperLogic.handleComplete}
          steps={stepperLogic.steps}
          completed={stepperLogic.completed}
          setCompleted={stepperLogic.setCompleted}
          handleBunkNumber={stepperLogic.handleBunkNumber}
        />
      );
    case 4:
      return (
        <TableChildren
          handleApplicantChange={stepperLogic.handleApplicantChange}
          handleSelectApplicantChange={stepperLogic.handleSelectApplicantChange}
          handleBack={stepperLogic.handleBack}
          handleNext={stepperLogic.handleNext}
          activeStep={stepperLogic.activeStep}
          completedSteps={stepperLogic.completedSteps}
          totalSteps={stepperLogic.totalSteps}
          handleComplete={stepperLogic.handleComplete}
          steps={stepperLogic.steps}
          completed={stepperLogic.completed}
          setCompleted={stepperLogic.setCompleted}
          handleBunkNumber={stepperLogic.handleBunkNumber}
        />
      );
    case 5:
      return <Scans activeStep={stepperLogic.activeStep} />;
    case 6:
      return (
        <Preview
          setActiveStep={stepperLogic.setActiveStep}
          activeStep={stepperLogic.activeStep}
        />
      );
    default:
      return 'Unknown step';
  }
}

export const CompletedContext = React.createContext();

const initialState = {};
const reducer = (state, action) => {
  switch (action.type) {
    case 'COMPLETED':
      return {
        ...state,
        ...action.payload
      };
    case 'CLEAR_COMPLETED':
      return {};
    default:
      return state;
  }
};

const CompletedProvider = ({ children }) => {
  const contextValue = React.useReducer(reducer, initialState);
  return (
    <CompletedContext.Provider value={contextValue}>
      {children}
    </CompletedContext.Provider>
  );
};

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

const mapStateToProps = state => ({
  stepper: state.applicant.stepper,
  enable: state.applicant.enable,
  rnokpp: state.auth.user.rnokpp
});

const enhanced = compose(
  withRouter,
  connect(mapStateToProps, {
    applicationIDAction,
    applicantAction,
    clearApplicantDocument,
    initAppID,
    getApplicationList
  })
);

const ContainerComponent = enhanced(function CustomizedSteppers(props) {
  const classes = styles.useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [enable, setEnabled] = React.useState({
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0
  });

  const [completedReducer, dispatch] = useCompleted();
  // console.log(completedReducer);
  const steps = getSteps();

  const isStepFailed = (step) => {

    
    return enable[step] === 0;
  };

  const isStepSkipped = step => {
    return enable.has(step);
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsAreTrue = () => {
    return Object.values(completed).every(item => item === 1);
  };

  const allStepsCompleted = () => {
    const aretrue = allStepsAreTrue();
    // console.log(aretrue);

    return completedSteps() === totalSteps() && allStepsAreTrue();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStep = step => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const handleApplicantChange = e => {
    const { name, value, checked } = e;
    switch (name) {
      //   break;
      case 'rnokpp_feature':
        props.applicantAction(name, checked);
        break;

      default:
        props.applicantAction(name, value.trim());
    }

    if (name === 'l_addressesmatch' && checked === false) {
      props.clearApplicantAddress();
    }
  };

  const handleSelectApplicantChange = (name, select) => {
    if (select) {
      const { value } = select;
      // console.log(select)
      if (name === 'p_id') {
        props.edrpouAction(select.edrpou);
        props.bankNameAction(select.label);
        props.mfoAction(select.value);
      } else {
        // this.props.requestDataDirectories(name, value)
        props.applicantAction(name, value);
      }
      if (
        name === 'documenttype' &&
        (value === 1 ||
          value === 2 ||
          value === 3 ||
          value === 4 ||
          value === 99)
      ) {
        props.clearApplicantDocument();
      }
    }
  };

  const handleBunkNumber = (name, value) => {
    props.applicantAction(name, value);
  };

  const stepperLogic = {
    handleApplicantChange,
    handleSelectApplicantChange,
    handleBack,
    handleNext,
    activeStep,
    completedSteps,
    totalSteps,
    handleComplete,
    steps,
    completed,
    setCompleted,
    handleBunkNumber,
    setActiveStep,
    pathName: props.location.pathname
  };

  React.useEffect(() => {
    dispatch({ type: 'COMPLETED', payload: props.stepper });
  }, [props.stepper]);

  React.useEffect(() => {
    setEnabled(props.enable);
  }, [props.enable]);

  React.useEffect(() => {
    // console.log(completed);
    // if (addPath) {
    //   props.initAppID();
    // }

    setCompleted(completedReducer);
  }, [completedReducer]);

  const handleHome = () => {
    props.initAppID();

    props.applicationIDAction(0);
    props.getApplicationList(props.rnokpp);
    props.history.push('/profile-page');
  };

  const getRoute = () => {
    return props.location.pathname === '/';
  };
  // console.log(completed);

  return (
    <div className={classes.root}>
      <Button variant="contained" color="primary" onClick={handleHome}>
        До списку заяв
      </Button>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<ColorlibConnector />}
          >
            {steps.map((label, index) => {
              const labelProps = {};
              const stepProps = {};
              // if (isStepOptional(index)) {
              //   labelProps.optional = (
              //     <Typography variant="caption" color="error">
              //       Alert message
              //     </Typography>
              //   );
              // }
              if (isStepFailed(index)) {
                labelProps.error = true;
                  //  stepProps.disabled = true;
                // labelProps.disabled = true;
              }
              // if (isStepSkipped(index)) {
              //   stepProps.disabled = true;
              //   labelProps.disabled = true;
              // }
              return (
                !isStepFailed(index, steps) && (
                  <Step key={label} {...stepProps}>
                    <StepLabel
                      onClick={handleStep(index)}
                      completed={completed[index]}
                      icon={label}
                      StepIconComponent={styles.ColorlibStepIcon}
                      {...labelProps}
                    >
                      <Typography component="p">{label}</Typography>
                    </StepLabel>
                  </Step>
                )
              );
            })}
          </Stepper>
        </Grid>
        <Grid item xs={12}>
          <div>
            {allStepsCompleted() ? (
              <div>
                <Typography
                  component="h3"
                  className={classes.instructions + ' text-success'}
                >
                  Заяву подано до УПСЗН
                </Typography>
                <Button onClick={handleHome}>На головну</Button>
              </div>
            ) : (
              <div>
                <div className={classes.instructions}>
                  {getStepContent(activeStep, stepperLogic)}
                </div>
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
});

export default function name(params) {
  return (
    <CompletedProvider>
      <ContainerComponent />
    </CompletedProvider>
  );
}
